//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Testimonial title
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Testimonial description
     */
    description: {
      type: String,
      required: true
    },
    /**
     * Testimonial author
     */
    author: {
      type: String,
      required: true
    },
    /**
     * Testimonial background
     */
    background: {
      type: String,
      required: true
    }
  },
  computed: {
    cssVars () {
      return {
        '--background-image': `url('${this.background}')`
      }
    }
  }
}

